import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Snackbar {
  id: number | string;
  title: string;
  isShown?: boolean;
  buttonText?: string;
  timer?: number;
  callback?: () => unknown;
}

export enum ToastType {
  Default = 'default',
  Error = 'error',
  Success = 'success',
}

export interface Toast {
  id: string | number;
  title: string;
  content?: string;
  toastType?: ToastType;
  isClosable?: boolean;
  timer?: number;
}

export default defineStore('toastSnack', () => {
  const snackbars = ref<Snackbar[]>([]);
  const toasts = ref<Toast[]>([]);

  function addToast(toast: Toast) {
    toasts.value.push(toast);
  }

  function addErrorToast(toast: Toast) {
    toast.toastType = ToastType.Error;
    addToast(toast);
  }

  function addSuccessToast(toast: Toast) {
    toast.toastType = ToastType.Success;
    addToast(toast);
  }

  function addSnackbar(newSnackbar: Snackbar) {
    if (!Object.prototype.hasOwnProperty.call(newSnackbar, 'isShown')) {
      newSnackbar.isShown = true;
    }

    snackbars.value.push(newSnackbar);
  }

  function clearToasts() {
    toasts.value = [];
  }

  function clearSnackbar(snackbarToRemove: Snackbar) {
    snackbars.value = snackbars.value.filter((item: Snackbar) => {
      return item.id !== snackbarToRemove.id;
    });
  }

  return {
    snackbars,
    toasts,
    addToast,
    addErrorToast,
    addSuccessToast,
    clearToasts,
    addSnackbar,
    clearSnackbar,
  };
});
